/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function($) {
	
	// Remove empty P tags created by WP inside of Accordion and Orbit
	$('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( $(this).innerWidth() / $(this).innerHeight() > 1.5 ) {
			$(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
			$(this).wrap("<div class='responsive-embed'/>");
		}
	});

	$( ".kt-blocks-post-footer" ).remove();

	$(".pdf-menu-link a").each(function() {
		$(this).attr('target', '_blank')
	});

	$('#maintenance-popup-btn').on('click', function(event) {
		event.preventDefault();
		$('#maintenance-popup').show();
		$('#popupOverlay').show();
	});

	$('.maintenance-popup a').on('click', function(event) {
		event.preventDefault();
		$('#maintenance-popup').show();
		$('#popupOverlay').show();
	});

	$('#popupOverlay').on('click', function() {
		$('#maintenance-popup').hide();
		$('#vacate-popup').hide();
		$('#popupOverlay').hide();
		$('#client-popup').hide();
	});

	$('#vacate-popup-btn').on('click', function(event) {
		event.preventDefault();
		$('#vacate-popup').show();
		$('#popupOverlay').show();
	});

	$('#client-popup-btn').on('click', function(event) {
		event.preventDefault();
		$('#client-popup').show();
		$('#popupOverlay').show();
	});

	$('#promotions-pdf .kt-testimonial-meta-wrap').wrap("<a href='http://northpointam.dev/wp-content/uploads/2024/05/Northpoint-Promotions-2018.pdf' aria-label='promotions pdf' target='_blank'></a>");

	$('#sell-your-property-pdf .kt-testimonial-meta-wrap').wrap("<a href='/wp-content/uploads/2024/05/Sell-Your-Home-DISCOUNT-Northpoint.pdf' aria-label='sell home pdf' target='_blank'></a>");

	$('#newsletter-pdf .kt-testimonial-meta-wrap').wrap("<a href='wp-content/uploads/2024/05/Placeholder-website.pdf' aria-label='newsletter pdf' target='_blank'></a>");

	
const ratingText = $('.location-rating').text().trim(); 
const rating = parseFloat(ratingText); 
const fullStars = Math.floor(rating); 
const hasHalfStar = rating % 1 !== 0; 

//console.log(rating, fullStars, hasHalfStar); 

const fullStarIcon = '<i class="fa-solid fa-star"></i>';
const halfStarIcon = '<i class="fa-solid fa-star-half"></i>';
let starsHtml = '';

if (rating != 0 || rating != NaN) {
	
	// Add full star icons
	for (let i = 0; i < fullStars; i++) {
		starsHtml += fullStarIcon;
	}
	
	// Add half star icon if needed
	if (hasHalfStar) {
		starsHtml += halfStarIcon;
	}
	
	// Append the stars after the rating element
	$('.location-rating').after(starsHtml);
}


	
}); 
